import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import css from './AppBadges.module.css';

// "Our iOS and Android apps are coming soon too." — the note plus the two store
// badges that sit under the hero call to action.
//
// The badges are drawn inline (no image files) so they stay sharp at any size.
// They are plain <span>s rather than links because neither app is published
// yet; each carries an aria-label so screen readers announce the store and the
// "coming soon" state. Swap them for Apple's and Google's official badge assets
// once the apps are live and the store links exist.

const AppleLogo = () => (
  <svg className={css.logo} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.05 12.54c.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.71-3.19-1.73-1.45-.11-2.66.82-3.35.82-.7 0-1.83-.8-3.01-.78-1.55.02-2.98.9-3.78 2.29-1.61 2.8-.41 6.94 1.16 9.21.77 1.11 1.69 2.35 2.9 2.31 1.16-.05 1.6-.75 3.01-.75 1.4 0 1.8.75 3.02.73 1.25-.02 2.05-1.13 2.81-2.25.88-1.29 1.24-2.54 1.26-2.6-.03-.01-2.42-.93-2.44-3.69M14.8 5.6c.62-.76 1.04-1.8.93-2.85-.89.04-1.99.6-2.63 1.35-.57.66-1.07 1.72-.94 2.74.99.08 2.01-.5 2.64-1.24" />
  </svg>
);

// The Play mark is a right-pointing shape split into four coloured wedges:
// green on top, red below, blue down the left spine, amber at the tip.
const PlayLogo = () => (
  <svg className={css.logo} viewBox="0 0 512 512" aria-hidden="true">
    <path fill="#00C853" d="M325.3 234.3 104.6 13l280.8 161.2-60.1 60.1z" />
    <path
      fill="#00A0FF"
      d="M47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256.6L47 0z"
    />
    <path fill="#FFBC00" d="M472.2 225.6l-58.9-34.1-65.7 65.5 65.7 65.5 60.1-34.1c18-14.3 18-46.5-1.2-62.8z" />
    <path fill="#FF3A44" d="M104.6 499l280.8-161.2-60.1-60.1L104.6 499z" />
  </svg>
);

const AppBadges = props => {
  const { className } = props;
  const intl = useIntl();

  return (
    <div className={className ? `${css.root} ${className}` : css.root}>
      <p className={css.note}>
        <FormattedMessage id="CustomLandingPage.hero.apps.note" />
      </p>

      <div className={css.badges}>
        <span
          className={css.badge}
          role="img"
          aria-label={intl.formatMessage({ id: 'CustomLandingPage.hero.apps.appStore' })}
        >
          <AppleLogo />
          <span className={css.badgeText} aria-hidden="true">
            <span className={css.badgeSmall}>Available on the</span>
            <span className={css.badgeLarge}>App Store</span>
          </span>
        </span>

        <span
          className={css.badge}
          role="img"
          aria-label={intl.formatMessage({ id: 'CustomLandingPage.hero.apps.googlePlay' })}
        >
          <PlayLogo />
          <span className={css.badgeText} aria-hidden="true">
            <span className={css.badgeSmall}>GET IT ON</span>
            <span className={css.badgeLarge}>Google Play</span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default AppBadges;
